import { createToken } from '@react-apps/core';
import type { FilesRepositoryImpl } from '../data/repositories/files.repository.impl';

export const FilesRepositoryToken =
  createToken<FilesRepositoryImpl>('FilesRepository');
